<template>
  <v-dialog v-model="dialog" width="600" class="semi-rounded">
    <v-card color="white" class="px-8 py-12 semi-rounded">
      <v-layout
        style="color: var(--primary-color-blue);"
        class="flex-column justify-center align-center title text-center"
      >
        <v-icon
          v-if="!hideIcon"
          class="mb-4"
          style="font-size: 4rem"
          color="#000230"
          >{{ dialogData.icon ? dialogData.icon : "info" }}</v-icon
        >
        <span v-if="dialogData.primary_text" class="py-6">{{
          dialogData.primary_text
        }}</span>
        <span v-if="dialogData.secondary_text" class="font-weight-bold">{{
          dialogData.secondary_text
        }}</span>
        <v-btn
          style="background: var(--primary-color-blue); color: white; border-radius: 16px !important;"
          class="py-8 px-10 mt-6 w-100"
          x-large
          @click="dialog = false"
        >
          {{ $t("actions.ok") }}
        </v-btn>
      </v-layout>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: ["dialogData", "hideIcon"],
  data() {
    return {
      dialog: false,
    };
  },
};
</script>
